import { Link } from "react-router-dom";
import { Phone, Printer, Mail, MapPin, Clock, Heart } from "lucide-react";
import { COMPANY } from "@/data/content";
import { useLocale } from "@/i18n/LocaleContext";

const linkCls =
  "text-white/80 hover:text-white transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 rounded";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { t, path } = useLocale();
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-dark text-white mt-auto"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Kontakt */}
          <div>
            <span className="mb-5 inline-flex rounded-2xl bg-white px-4 py-3">
              <img
                src="/images/logo.png"
                alt={COMPANY.name}
                width="616"
                height="200"
                loading="lazy"
                className="h-12 w-auto"
              />
            </span>
            <address className="not-italic flex items-start gap-2.5 text-white/80">
              <MapPin className="w-5 h-5 mt-1 shrink-0 text-gold" />
              <span className="ltr">
                {COMPANY.address.street}
                <br />
                {COMPANY.address.zip} {COMPANY.address.city}
              </span>
            </address>
          </div>

          {/* Erreichbarkeit */}
          <div>
            <h3 className="font-serif text-lg font-600 mb-4">{t.footer.reach}</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-gold shrink-0" />
                <a className={`${linkCls} whitespace-nowrap`} href={`tel:${COMPANY.phoneRaw}`}>
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Printer className="w-4 h-4 text-gold shrink-0" />
                <span className="whitespace-nowrap">{t.footer.fax} <span className="ltr">{COMPANY.fax}</span></span>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-gold shrink-0" />
                <a className={linkCls} href={`mailto:${COMPANY.email}`}>
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Clock className="w-4 h-4 mt-1 text-gold shrink-0" />
                <span className="flex flex-col leading-snug">
                  <span>{t.footer.emergency}</span>
                  <a className={`${linkCls} whitespace-nowrap font-600 text-white`} href={`tel:${COMPANY.emergencyRaw}`}>
                    {COMPANY.emergency}
                  </a>
                </span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-serif text-lg font-600 mb-4">{t.footer.navigation}</h3>
            <ul className="space-y-2.5">
              <li><Link className={linkCls} to={path("home")}>{t.nav.home}</Link></li>
              <li><Link className={linkCls} to={path("about")}>{t.nav.about}</Link></li>
              <li><Link className={linkCls} to={path("services")}>{t.nav.services}</Link></li>
              <li><Link className={linkCls} to={path("news")}>{t.nav.news}</Link></li>
              <li><Link className={linkCls} to={path("contact")}>{t.nav.contact}</Link></li>
              <li><Link className={linkCls} to={path("news", "stellenanzeigen")}>{t.nav.jobs}</Link></li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="font-serif text-lg font-600 mb-4">{t.footer.legal}</h3>
            <ul className="space-y-2.5">
              <li><Link className={linkCls} to={path("imprint")}>{t.nav.imprint}</Link></li>
              <li><Link className={linkCls} to={path("privacy")}>{t.nav.privacy}</Link></li>
            </ul>
            <div className="mt-6 flex items-center gap-2 text-white/70 text-sm">
              <Heart className="w-4 h-4 text-gold" />
              <span>{t.footer.area}</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 text-center text-white/60 text-sm">
          © {year} {COMPANY.name}. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
